<template>
    <div class="flex pv10">
        <img src="/static/img/logo2.png" width="160" alt="虹星科技" />
        <ul class="fs14 c-g-d lh24 ml20 pt10">
            <li>销售咨询热线: 400-696-1828</li>
            <li>技术咨询热线: 400-696-1828</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "SalesHotline",
};
</script>

<style lang="less"></style>